import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { history } from "helpers";
import { GetEasySeatJSONObject } from "helpers/trasform";
import EasySeatItemRowWidgetNew from "components/subcomponents/EasySeatItemRowWidget";
import { IsValidEasySeatData } from "helpers/filter";
import { CButton, CCard, CCardBody } from "@coreui/react-pro";
import FontAwesome from "react-fontawesome";
import $ from "jquery";
import axios from 'axios';
import { renderToString } from "react-dom/server";
import SndUnknown from "assets/sounds/Unknown.mp3";
import SndLightBuddy from "assets/sounds/LightBuddy.mp3";
import SndBuddy from "assets/sounds/Buddy.mp3";
import SndMegaBuddy from "assets/sounds/MegaBuddy.mp3";
import SndUltraBuddy from "assets/sounds/UltraBuddy.mp3";
import { RemoveSpaceInText } from "helpers/filter";
import {
  LIGHTBUDDY,
  MEGABUDDY,
  ULTRABUDDY,
  BUDDY,
  UNKNOWN,
  TT_BP,
  TELEGRAM_BOT_TOKEN,
} from "constant/constant";
import {
  supaClient,
  GetPlayersBynIDs,
} from "helpers/supabase";
import useSound from "use-sound";
import { GetTelegramAdminSetting } from "helpers/admin/supabase";
import EasySeatAlertForTelegram from "components/subcomponents/EasySeatAlertForTelegram";

const DashboardPage = () => {

  const telegramSetting = useSelector((state) => state.telegramSettingState.telegramSetting);
  const [playUnknown] = useSound(SndUnknown, { interrupt: true });
  const [playLightBuddy] = useSound(SndLightBuddy, { interrupt: true });
  const [playBuddy] = useSound(SndBuddy, { interrupt: true });
  const [playUltraBuddy] = useSound(SndUltraBuddy, { interrupt: true });
  const [playMegaBuddy] = useSound(SndMegaBuddy, { interrupt: true });

  const pColors = useSelector((state) => state.playerColorState.playerColors);
  const dispatch = useDispatch();
  const profiles = useSelector((x) => x.profileState.profiles);
  const realStacks = useSelector((x) => x.stackConvertorState.data);
  const siteUnionsClubs = useSelector((x) => x.siteUnionClubState.data);
  const soundOnOff = useSelector((state) => state.changeState.soundOnOff);
  const fullScreenMode = useSelector((state) => state.changeState.fullScreenMode);
  const [showDropdown, setShowDropdown] = useState(false);
  const [started, setStarted] = useState(false);
  const sidebarShow = useSelector((state) => state.changeState.sidebarShow);

  const curProfileIndex = useSelector(
    (x) => x.profileState.currentProfileIndex
  );
  const curTeleProfileIndex = useSelector(
    (x) => x.profileState.currentTeleProfileIndex
  );

  const parentDivRef = useRef(null);

  if (profiles.length === 0) {
    return (
      <CCard className="mb-2 mt-2">
        <CCardBody
          style={{ background: "darkred", borderRadius: "6px", color: "white" }}
        >
          <h4>
            <FontAwesome
              name="triangle-exclamation"
              size="lg"
              style={{ color: "yellow" }}
            ></FontAwesome>{" "}
            You can never use any clubs now. Please have a contact with
            adminstrator.{" "}
          </h4>
        </CCardBody>
      </CCard>
    );
  }
  const startButton_OnClick = () => {
    setStarted(true);
  }

  let datas = [];

  useEffect(() => {

    if (history.location.pathname.includes("dashboard")) {
      dispatch({ type: "set", showProfile: true });
    } else {
      dispatch({ type: "set", showProfile: false });
    }

    if (fullScreenMode === 0) {
      parentDivRef.current.style.border = 'none';
    } else if (fullScreenMode === 1) {
      parentDivRef.current.style.border = '1px solid #c1bfbf';
    } else {
      const divElements = parentDivRef.current.getElementsByTagName('div');
      if (divElements.length > 1) {
        parentDivRef.current.style.border = '1px solid #c1bfbf';
      }
    }

    const playSound = async (playertype) => {
      if (!soundOnOff) return;
      try {
        switch (playertype) {
          case UNKNOWN:
            await playUnknown();
            break;
          case LIGHTBUDDY:
            await playLightBuddy();
            break;
          case BUDDY:
            await playBuddy();
            break;
          case ULTRABUDDY:
            await playUltraBuddy();
            break;
          default:
            await playMegaBuddy();
            break;
        }
      } catch (error) {
        console.error("Error playing sound:", error);
      }
    };

    const taskListener = supaClient
      .channel("public:easyseat_data")
      .on(
        "postgres_changes",
        { event: "INSERT", schema: "public", table: "easyseat_data" },
        (payload) => {
          if (payload.new) {
            if (!started) return;
            let new_data = GetEasySeatJSONObject(payload.new);

            GetPlayersBynIDs(new_data["site"], new_data["nids"]).then(
              (rval) => {
                if (rval === null) return;
                rval.forEach((ele) => {
                  new_data["playertypes"][ele["nid"]] = ele["playertype"];
                });

                if (new_data["playertype"] !== "") {
                  if (new_data["playertype"] !== null) {
                    if (
                      new_data["playertypes"][new_data["nid"]] === UNKNOWN
                    ) {
                      new_data["playertypes"][new_data["nid"]] =
                        new_data["playertype"];
                    }
                  }
                }
                if (
                  IsValidEasySeatData(
                    new_data,
                    profiles[curProfileIndex],
                    siteUnionsClubs,
                    realStacks
                  )
                ) {
                  RemoveUnnessaryTableType(new_data);
                  playSound(new_data["playertypes"][new_data["nid"]])
                  AppendEasySeatDataRow(new_data);
                }
                if (
                  IsValidEasySeatData(
                    new_data,
                    profiles[curTeleProfileIndex],
                    siteUnionsClubs,
                    realStacks
                  )
                ) {
                  RemoveUnnessaryTableTypeForTele(new_data);
                  SendEasySeatAlertForTelegram(new_data);
                }
              }
            );
          }
        }
      )
      .subscribe();
    return () => {
      taskListener.unsubscribe();
    };
  }, [
    dispatch,
    supaClient,
    siteUnionsClubs,
    realStacks,
    profiles,
    curProfileIndex,
    curTeleProfileIndex,
    soundOnOff,
    sidebarShow,
    pColors,
    fullScreenMode,
    telegramSetting,
    started,
    playUnknown,
    playLightBuddy,
    playBuddy,
    playUltraBuddy,
    playMegaBuddy
  ]);

  useEffect(() => {
    const handleInteraction = () => {
      setShowDropdown(true);
      setTimeout(() => {
        setShowDropdown(false);
      }, 6000);
    };


    window.addEventListener("click", handleInteraction);
    window.addEventListener("touchstart", handleInteraction);

    return () => {

      window.removeEventListener("click", handleInteraction);
      window.removeEventListener("touchstart", handleInteraction);
    };
  }, []);

  const AppendEasySeatDataRow = (data) => {
    const parentDiv = $(".easyseat-dashboard-content");
    // if (fullScreenMode !== 0) {
    //   parentDiv.css({ border: "1px solid #c1bfbf" });
    // }
    const childDiv = renderToString(GetEasySeatDataRow(data));
    parentDiv.append(childDiv);
    parentDiv.animate({ scrollTop: 5000 }, "slow");
    // $("html, body").scrollTop($(document).height());
    datas.push(data);
    while (datas.length > 120) {
      datas.shift();
      parentDiv.children().first().remove();
    }
  };


  const SendEasySeatAlertForTelegram = (data) => {
    const childDiv = renderToString(GetEasySeatDataRowForTele(data));
  };

  const GetFullScreenIcon = () => {
    return <FontAwesome name="compress"
      size="lg"
      style={{
        color: '#cfd0b6',
        cursor: 'pointer',
        border: '2px solid #888',
        borderRadius: '5px',
        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
        padding: '0px',
      }}
    ></FontAwesome>;
  };

  const SetDisableFullScreenMode = () => {
    dispatch({ type: "set", sidebarShow: true });
    dispatch({ type: "set", fullScreenMode: -1 });
  }

  const GetEasySeatDataRow = (a) => {
    return (
      <EasySeatItemRowWidgetNew
        key={a["id"]}
        a={a}
        pt={profiles[curProfileIndex]["playertype"]}
        minPlayerType={profiles[curProfileIndex]["min_player_type"]}
        pColors={pColors}
        siteUnionClubs={siteUnionsClubs}
        soundOnOff={soundOnOff}
        telegramSetting={telegramSetting}
      />
    );
  };

  const GetEasySeatDataRowForTele = (a) => {
    return (
      <EasySeatAlertForTelegram
        key={a["id"]}
        a={a}
        pt={profiles[curTeleProfileIndex]["playertype"]}
        minPlayerType={profiles[curTeleProfileIndex]["min_player_type"]}
        siteUnionClubs={siteUnionsClubs}
        telegramSetting={telegramSetting}
      />
    );
  };

  const RemoveUnnessaryTableType = (incoming_data) => {
    var updated_table_type = [];
    var isNoExistBP = false;

    if (
      incoming_data["bombpothand"] === null ||
      incoming_data["bombpothand"] === undefined
    ) {
      isNoExistBP = true;
    }
    if (incoming_data["bombpothand"] === "") {
      isNoExistBP = true;
    }

    incoming_data["tabletype"].forEach((ele) => {
      var isflag = false;
      profiles[curProfileIndex]["tabletype"].forEach((ele1) => {
        if (RemoveSpaceInText(ele1.text) === RemoveSpaceInText(ele)) {
          isflag = true;
        }
      });
      if (isflag) {
        updated_table_type.push(ele);
        isflag = false;
      }
    });
    if (!isNoExistBP) {
      updated_table_type.push(TT_BP);
    }
    incoming_data["tabletype"] = updated_table_type;
  };

  const RemoveUnnessaryTableTypeForTele = (incoming_data) => {
    var updated_table_type = [];
    var isNoExistBP = false;

    if (
      incoming_data["bombpothand"] === null ||
      incoming_data["bombpothand"] === undefined
    ) {
      isNoExistBP = true;
    }
    if (incoming_data["bombpothand"] === "") {
      isNoExistBP = true;
    }

    incoming_data["tabletype"].forEach((ele) => {
      var isflag = false;
      profiles[curTeleProfileIndex]["tabletype"].forEach((ele1) => {
        if (RemoveSpaceInText(ele1.text) === RemoveSpaceInText(ele)) {
          isflag = true;
        }
      });
      if (isflag) {
        updated_table_type.push(ele);
        isflag = false;
      }
    });
    if (!isNoExistBP) {
      updated_table_type.push(TT_BP);
    }
    incoming_data["tabletype"] = updated_table_type;
  };

  return (
    <div ref={parentDivRef} className="align-items-center easyseat-dashboard-content" style={{ position: "relative" }}>
      {!started && (
        <div
          className="easyseat-dashboard-start-dlg"
          style={{
            left: sidebarShow ? "50%" : "50%",
            position: "absolute", // Add this if not already in your CSS
          }}
        >
          <p style={{ color: "#ffff9f", fontSize: "20px", marginBottom: "20px", width: "240px" }}>
            Press <b>START</b> to get alerts
          </p>
          <CButton
            onClick={startButton_OnClick}
            style={{
              padding: "10px 20px",
              fontSize: "24px",
              cursor: "pointer",
            }}
          >
            START
          </CButton>
        </div>
      )}

      {showDropdown && (
        <div
          style={{
            position: "fixed",
            top: "2px",
            right: "2px",
            transition: "opacity 1s",
            opacity: showDropdown ? 1 : 0,
            zIndex: 1000,
          }}
          onClick={SetDisableFullScreenMode}
        >
          {GetFullScreenIcon()}
        </div>
      )}
    </div>
  );
};
export default React.memo(DashboardPage);
